import {
  formatSriLankaDate,
  formatSriLankaDateTime,
  sriLankaToday,
} from "./sriLankaTime";

export const currency = (value) => {
  const n = Number(value || 0);
  return `Rs. ${n.toLocaleString("en-LK", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const dateTime = (iso) => {
  return formatSriLankaDateTime(iso);
};

export const dateOnly = (iso) => {
  return formatSriLankaDate(iso);
};

export const todayISO = () => sriLankaToday();
